import { RcaOutcomeState } from '@pages/app/rca/outcome/rca-outcome-hook';

export default function useOutcomePreviewStep(state: RcaOutcomeState) {
  return {
    isLoading: state.isLoading,
    outcomeDetail: state.outcomeDetail,
  };
}
